<template>
  <div class="trade">
    <ul class="f-m-l-md f-m-r-md navbtnbox row">
      <li class="active">标准工业行业</li>
    </ul>

    <div class="content f-h-full f-webkit-box f-box-vertical">
      <div class="f-b f-b-color-008efc f-m-l-xls">
        <div
          class="layui-cards-title f-lh-36 f-h-36 f-color-white f-p-l-xlg f-size-18"
          id="divBzhy"
        >
          {{ industryName }}
        </div>
        <div class="f-webkit-box f-m-l-md f-m-r-md f-p-b">
          <div class="f-box-flex1 f-m-r">
            <div class="layui-panel f-p-xxs f-h-full">
              <div class="titlebg f-webkit-box f-box-vertical">
                <div class="f-lh-32 f-h-36 f-color-white f-p-l f-size-18">
                  企业数
                </div>
                <div
                  class="f-webkit-box f-p-t-sm f-p-b-sm f-h-100 f-box-align-c f-p-l"
                >
                  <div class="xgbg2 f-h-full f-info-c f-p-t-xs">
                    <i class="iconfont f-size-30">&#xe6cd;</i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="bzhy1"
                        >{{ qiYeShu }}</span
                      >个
                    </div>
                    <div class="f-color-2f85b1 f-size-14">当前累计</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="f-box-flex1 f-m-r">
            <div class="layui-panel f-p-xxs f-h-full">
              <div class="f-lh-32 f-h-36 f-color-white f-p-l f-size-18">
                增加值
              </div>
              <div
                class="f-webkit-box f-p-t-sm f-p-b-sm f-p-l f-p-r f-h-100 f-box-align-c f-box-space-around"
              >
                <div
                  class="f-webkit-box"
                  v-for="(item, index) in zengJiaZhi"
                  :key="index"
                >
                  <div class="xgbg2 f-h-full">
                    <i class="iconfont icon1"></i>
                  </div>
                  <div class="f-m-l-sm">
                    <div
                      class="f-color-white f-size-14"
                      :class="item.growth >= 0 ? 'upicon' : 'downicon'"
                    >
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="bzhy2"
                        >{{ item.growth == null ? "--" : item.growth }}</span
                      >%
                    </div>
                    <div class="f-color-2f85b1 f-size-14">{{ item.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="f-box-flex1 f-m-r">
            <div class="layui-panel f-p-xxs f-h-full">
              <div class="titlebg f-webkit-box f-box-vertical">
                <div class="f-lh-32 f-h-36 f-color-white f-p-l f-size-18">
                  主营业务收入
                </div>
                <div
                  class="f-webkit-box f-p-t-sm f-p-b-sm f-h-100 f-box-align-c f-box-space-around"
                >
                  <div class="f-webkit-box">
                    <div class="xgbg2 f-h-full">
                      <i class="iconfont icon2"></i>
                    </div>
                    <div class="f-m-l-sm">
                      <div class="f-color-white f-size-14">
                        <span
                          class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                          id="bzhy5"
                          >{{
                            zhuYingYeWu.money == null ? "--" : zhuYingYeWu.money
                          }}</span
                        >万元
                      </div>
                      <div class="f-color-2f85b1 f-size-14">当期累计</div>
                    </div>
                  </div>
                  <div
                    class="f-color-white f-size-14"
                    :class="zhuYingYeWu.growth >= 0 ? 'upicon' : 'downicon'"
                  >
                    <span
                      class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                      id="bzhy6"
                      >{{
                        zhuYingYeWu.growth == null ? "--" : zhuYingYeWu.growth
                      }}</span
                    >%
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="f-box-flex1">
            <div class="layui-panel f-p-xxs f-h-full">
              <div class="titlebg f-webkit-box f-box-vertical">
                <div class="f-lh-32 f-h-36 f-color-white f-p-l f-size-18">
                  利润总额
                </div>
                <div
                  class="f-webkit-box f-p-t-sm f-p-b-sm f-h-100 f-box-align-c f-box-space-around"
                >
                  <div class="f-webkit-box">
                    <div class="xgbg2 f-h-full">
                      <i class="iconfont icon2"></i>
                    </div>
                    <div class="f-m-l-sm">
                      <div class="f-color-white f-size-14 upicon">
                        <span
                          class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                          id="bzhy7"
                          >{{
                            liRunZongE.money == null ? "--" : liRunZongE.money
                          }}</span
                        >万元
                      </div>
                      <div class="f-color-2f85b1 f-size-14">当前累计</div>
                    </div>
                  </div>
                  <div
                    class="f-color-white f-size-14"
                    :class="liRunZongE.growth >= 0 ? 'upicon' : 'downicon'"
                  >
                    <span
                      class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                      id="bzhy8"
                      >{{
                        liRunZongE.growth == null ? "--" : liRunZongE.growth
                      }}</span
                    >%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="f-webkit-box f-box-flex1 f-m-t">
        <div class="f-box-flex1">
          <div class="f-h-full pbg2" style="padding-bottom: 13px">
            <div
              class="f-h-full layui-panel2 f-webkit-box f-box-vertical bg002"
            >
              <div class="ctnav">
                <div
                  class="layui-cards-title f-lh-32 f-color-white f-p-l-xlg f-size-18"
                >
                  标准工业行业主营业务收入占比
                </div>
              </div>
              <div class="selector" style="width: 50px" @click="fanhui()">
                <a href="javascript:;">
                  <i
                    id="picture5"
                    class="layui-icon el-icon-back"
                    title="返回"
                  ></i>
                </a>
              </div>
              <!-- :style="dis_none ? 'dispaly:blcok' : 'dispaly:none'" -->

              <div
                class="f-box-flex1 f-m"
                :class="dis_none ? 'dis_block' : 'dis_noShow'"
                id="main1_ind"
              ></div>
            </div>
          </div>
        </div>
        <div class="f-box-flex1 f-m-l pbg2" style="padding-bottom: 13px">
          <div class="f-h-full layui-panel2 f-webkit-box f-box-vertical bg002">
            <div class="ctnav">
              <div
                class="layui-cards-title f-lh-32 f-h-32 f-color-white f-p-l-xlg f-size-18"
                id="divBzhytrend"
              >
                {{ industryName }}发展走势
              </div>
            </div>
            <div class="f-box-flex1 f-m" id="main2_ind"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="display:none" id="main7_area"></div>
    <div style="display:none" id="main6_area"></div>
    <div style="display:none" id="map"></div>-->
  </div>
</template>

<script>
export default {
  name: "trade",
  props: ["searchYearMonth"],
  data() {
    return {
      dis_none: true,
      showJ: true,
      tabsParam: ["增加值增速", "工业投资增速"],
      nowIndex: 0, //默认第一个tab为激活状态
      qiYeShu: 0,
      zengJiaZhi: [],
      zhuYingYeWu: {},
      liRunZongE: {},
      zyywdq: "--",
      zyywlj: "--",
      zyywljicon: "",
      lrze: "--",
      lrzedq: "--",
      lrzedqicon: "",
      month: this.searchYearMonth,
      industryName: "标准工业行业",
    };
  },
  components: {},
  watch: {
    searchYearMonth: function (val) {
      this.month = val;
      this.getData(this.month, null);
      this.getBzhyzb(this.month);
      this.getBzhytrend(this.month, null);
    },
  },
  created() {
    this.getCurrentDateTime();
  },

  mounted() {
    this.getData(this.month, null);
    this.getBzhyzb(this.month);
    this.getBzhytrend(this.month, null);
    this.getIndexYearMonth(this.month);
  },
  methods: {
    getIndexYearMonth(value) {
      this.$emit("getYearMonth", value);
    },
    /*获取当前时间开始*/
    getCurrentDateTime() {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;

      if (month < 10) {
        month = "0" + month;
      }
      var YM = year + "-" + month;
      this.getData(YM, null);
      this.getBzhyzb(YM);
      this.getBzhytrend(YM, null);
    },
    /*获取当前时间结束*/
    fanhui() {
      window.location.reload();
    },
    /*'增加值增速','工业投资增速'  切换开始*/
    toggleTabs: function (index) {
      this.nowIndex = index;
    },
    /*'增加值增速','工业投资增速'  切换结束*/

    getData(month, name) {
      //企业数
      this.$axios
        .get("/business/monitor/industry/selectIndustryNum", {
          params: {
            dateRange: month,
            industryType: name,
          },
        })
        .then((res) => {
          this.qiYeShu = res.data.data;
        });
      //增加值
      this.$axios
        .get("/business/monitor/industry/selectIndustryAddVal", {
          params: {
            dateRange: month,
            industryType: name,
          },
        })
        .then((res) => {
          this.zengJiaZhi = res.data.data;
        });
      //主营业务
      this.$axios
        .get("/business/monitor/industry/selectIndustryBusIncome", {
          params: {
            dateRange: month,
            industryType: name,
          },
        })
        .then((res) => {
          if (res.data.data) {
            this.zhuYingYeWu = res.data.data;
          } else {
            this.zhuYingYeWu = { money: null, growth: null };
          }
        });
      //利润总额
      this.$axios
        .get("/business/monitor/industry/selectIndustryProfit", {
          params: {
            dateRange: month,
            industryType: name,
          },
        })
        .then((res) => {
          if (res.data.data) {
            this.liRunZongE = res.data.data;
          } else {
            this.liRunZongE = { money: null, growth: null };
          }
        });
    },
    //标准工业行业主营收入占比开始
    getBzhyzb(month) {
      this.$axios
        .get("/business/monitor/industry/selectIndustryProportion", {
          params: {
            dateRange: month,
          },
        })
        .then((result) => {
          if (result.data.data.length > 0) {
            this.dis_none = true;
            var arr = result.data.data;
            var data = [];
            for (var i = 0; i < arr.length; i++) {
              data.push({
                value: arr[i].proportion,
                ljtb: arr[i].growth ? arr[i].growth : "--",
                zb: arr[i].sum,
                name: arr[i].name,
              });
            }
            this.treemap("main1_ind", data);
          } else {
            this.dis_none = false;
            this.treemap("main1_ind", []);
          }
        });
    },

    treemap(id, data) {
      var that = this;
      var chart = this.$echarts.init(document.getElementById(id));
      // chart.clear();
      var option = {
        color: ["#4483fb", "#1ccee0", "#fff443", "#004b9a", "#e99c30"],
        tooltip: {
          trigger: "item",
          formatter: function (value) {
            return (
              "<span class='f-size-18'>" +
              value.data.name +
              "</span><br/>当期累计：" +
              value.data.zb +
              "亿元<br/>累计同比：" +
              value.data.ljtb +
              "%<br/>占总比：" +
              value.data.value +
              "%"
            );
          },
          backgroundColor: "rgb(6,22,64)",
          borderColor: "#3679be",
          extraCssText: "box-shadow:0 0 6px 2px #0086e8 inset",
          padding: [24, 20, 24, 20],
          textStyle: {
            color: "#2d83b6",
          },
        },
        series: {
          type: "treemap",
          breadcrumb: {
            show: false,
          },
          data: data,
          width: "95%",
          height: "95%",
        },
      };
      chart.setOption(option);
      chart.on("click", function (as) {
        var name = as.name;
        that.getBzhytrend(that.month, name);
        that.industryName = name;
        that.getData(that.month, name);
      });
    },
    //标准工业行业主营收入占比结束

    //标准工业行业发展趋势开始
    getBzhytrend(month, name) {
      this.$axios
        .get("/business/monitor/industry/selectIndustryDevelopTrend", {
          params: {
            dateRange: month,
            industryType: name,
          },
        })
        .then((result) => {
          var arr = result.data.data;
          var dataAxis = [];
          var data1 = [];
          var data2 = [];
          var data3 = [];
          var data4 = [];
          var data5 = [];
          for (var i = 0; i < arr.length; i++) {
            dataAxis.push(arr[i].monthQuery);
            data1.push(arr[i].bus);
            data2.push(arr[i].profit);
            data3.push(arr[i].busGrowth);
            data4.push(arr[i].profitGrowth);
            data5.push(arr[i].addGrowth);
          }

          var data = {
            dataAxis: dataAxis,
            color: [
              ["#e99b30", "#f1e024"],
              ["#14d6dc", "#4178ff"],
            ],
            data: [
              {
                name: "主营业务收入",
                data: data1,
              },
              {
                name: "利润总额",
                data: data2,
              },
              {
                name: "主营业务收入累计同比",
                yIndex: 1,
                data: data3,
              },
              {
                name: "利润累计同比",
                yIndex: 1,
                data: data4,
              },
              {
                name: "增加值累计增速",
                yIndex: 1,
                data: data5,
              },
            ],
          };
          this.combine("main2_ind", data);
        });
    },

    combine(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      var datas = data.data;
      var newdata = new Object();
      newdata.series = [];
      newdata.legend = [];
      for (var i = 0; i < datas.length; i++) {
        var d = datas[i];
        var color = data.color[i];
        newdata.legend.push(d.name);
        if (d.hasOwnProperty("yIndex") && d.yIndex > 0) {
          newdata.series.push({
            name: d.name,
            type: "line",
            yAxisIndex: 1,
            data: d.data,
            barWidth: "20%",
          });
        } else {
          newdata.series.push({
            name: d.name,
            type: "bar",
            // barWidth: 10,
            yAxisIndex: 0,
            data: d.data,
            barWidth: "20%",
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: color[0], // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: color[1], // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          });
        }
      }
      var option = {
        color: ["#008efb", "#FF7F4C", "#00FFFF", "#7396FF"],
        tooltip: {
          trigger: "axis",
          confine: true,
        },
        title: {
          top: 5,
          left: "center",
          text: data.title,
          textStyle: {
            color: "#2375a1",
            fontSize: 14,
          },
        },
        legend: {
          textStyle: {
            color: "#2670a0",
          },
          data: newdata.legend,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            name: "单位：万元",
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            nameTextStyle: {
              color: "#2a80bc",
            },
            axisLabel: {
              color: "#2a80bc",
            },
            axisLine: {
              lineStyle: {
                color: "#1a41b6",
              },
            },
          },
          {
            type: "value",
            name: "单位：%",
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            nameTextStyle: {
              color: "#2a80bc",
            },
            axisLabel: {
              color: "#2a80bc",
            },
            axisLine: {
              lineStyle: {
                color: "#1a41b6",
              },
            },
          },
        ],
        xAxis: {
          type: "category",
          axisPointer: {
            type: "shadow",
          },
          axisTick: {
            show: false,
          },
          nameTextStyle: {
            color: "#2a80bc",
          },
          axisLabel: {
            color: "#2a80bc",
          },
          axisLine: {
            lineStyle: {
              color: "#1a41b6",
            },
          },
          data: data.dataAxis,
        },
        series: newdata.series,
      };
      chart.setOption(option);
    },
    //标准工业行业发展趋势结束

    //箭头标识设置开始
    setZbClass(v) {
      if (v) {
        return v >= 0 ? "upicon" : "downicon";
      }
    },
    //箭头标识设置开始
  },
};
</script>

<style scoped>
.nonexs {
  display: none;
}
.blockxs {
  display: block;
}
.trade {
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 40px;
}

.layui-panel {
  background: url(../../../assets/img/bg001.png) center no-repeat;
  background-size: 100% 100%;
}

.layui-cards-title {
  background: url(../../../assets/img/jiantou.png) no-repeat;
}

.bg002 {
  background: url(../../../assets/img/bg002.png) center no-repeat;
  background-size: 100% 100%;
}

.f-right {
  height: 66px;
}

.f-b-color-008efc {
  border-color: #008efc;
}

.layui-cutline {
  background: url(../../../assets/img/xuxian01.png) center center no-repeat;
  background-size: 100% 100%;
}

.layui-cutline-left {
  background: url(../../../assets/img/xuxian02.png) center center no-repeat;
  background-size: 100% 100%;
}

.xgbg2 {
  height: 60px;
}
.dis_block {
  opacity: 1;
}
.dis_noShow {
  opacity: 0;
}
</style>